import styles from '../styles/LegalWarning.module.css';

const LegalWarning = () => {
    return(
        <div className={styles.warningBox}>
            <strong>Legal Warning</strong>
            <p>
                Unauthorized access to this application is strictly prohibited and may be subject to criminal prosecution. Accessing or attempting to access this system without
                authorization constitutes an offense punishable by law. By proceeding, you acknowledge that you have read, understood, and agreed to comply with these terms.
            </p>
            <small>
                <a href='https://uscode.house.gov/view.xhtml?req=granuleid:USC-prelim-title18-section1030&num=0&edition=prelim' target='_blank' rel='noopener noreferrer'>18 U.S. Code &sect; 1030</a>
                <br />
                <a href='https://apps.legislature.ky.gov/law/statutes/statute.aspx?id=18918' target='_blank' rel='noopener noreferrer'>KRS 434.845</a>
            </small>
        </div>
    )
}

export default LegalWarning;